import React from 'react';

export interface BreakpointContextValue<T> {
  matchedBreakpoints?: (keyof T)[];
  breakpoints?: T;
}

export const BreakpointContext =
  React.createContext<BreakpointContextValue<any> | null>(null);
